// extracted by mini-css-extract-plugin
module.exports = {"Contact":"styles_Contact__1vKMs","fadeIn":"styles_fadeIn__avBel","Contact-wrapper":"styles_Contact-wrapper__rEEm4"};